const validROISortCodes = [
    '904130',
    '901597',
    '903162',
    '906451',
    '903170',
    '903189',
    '904149',
    '903197',
    '901634',
    '900965',
    '906494',
    '901490',
    '903218',
    '903541',
    '905248',
    '905272',
    '903680',
    '902645',
    '903699',
    '900973',
    '903234',
    '904712',
    '900105',
    '903701',
    '903728',
    '901642',
    '905280',
    '904739',
    '906507',
    '901650',
    '902581',
    '902602',
    '909601',
    '905299',
    '901677',
    '902688',
    '901028',
    '900420',
    '906515',
    '905328',
    '901036',
    '904165',
    '904747',
    '906523',
    '904755',
    '904763',
    '900762',
    '905934',
    '905651',
    '905942',
    '900113',
    '906531',
    '904771',
    '900316',
    '903269',
    '905336',
    '905969',
    '902979',
    '905977',
    '903744',
    '903277',
    '905985',
    '905678',
    '901685',
    '905352',
    '904595',
    '903293',
    '900914',
    '905360',
    '905694',
    '901693',
    '903760',
    '903779',
    '902610',
    '900121',
    '903306',
    '906005',
    '902637',
    '900017',
    '904966',
    '900471',
    '903314',
    '902768',
    '902813',
    '900324',
    '905707',
    '904835',
    '904181',
    '902709',
    '903322',
    '900519',
    '905387',
    '900746',
    '906750',
    '901116',
    '903349',
    '903365',
    '901095',
    '906021',
    '904878',
    '903429',
    '902848',
    '903787',
    '903437',
    '901714',
    '901722',
    '905395',
    '901757',
    '904210',
    '906566',
    '904229',
    '903816',
    '905117',
    '902864',
    '900551',
    '905512',
    '904042',
    '903795',
    '909062',
    '900578',
    '904894',
    '906603',
    '903867',
    '906611',
    '901749',
    '903621',
    '901132',
    '903875',
    '900164',
    '901247',
    '900877',
    '905723',
    '903445',
    '905731',
    '901140',
    '901167',
    '904237',
    '906064',
    '901183',
    '905758',
    '900594',
    '905766',
    '904907',
    '906072',
    '904536',
    '904253',
    '903883',
    '903461',
    '900818',
    '902557',
    '904915',
    '904309',
    '906216',
    '906080',
    '905782',
    '909708',
    '901773',
    '903891',
    '901204',
    '905790',
    '900607',
    '902880',
    '905408',
    '900543',
    '909580',
    '901503',
    '901212',
    '902901',
    '905803',
    '904333',
    '902944',
    '901781',
    '905416',
    '903488',
    '901220',
    '903912',
    '901810',
    '901829',
    '904990',
    '901853',
    '901239',
    '903509',
    '904368',
    '906638',
    '901263',
    '904376',
    '904587',
    '904018',
    '900033',
    '903517',
    '904034',
    '903939',
    '900623',
    '901861',
    '901888',
    '903947',
    '900658',
    '900172',
    '901298',
    '902012',
    '906654',
    '900201',
    '904384',
    '900754',
    '903648',
    '905424',
    '904392',
    '906742',
    '904499',
    '903840',
    '906160',
    '904413',
    '904528',
    '904421',
    '900893',
    '902952',
    '905440',
    '900092',
    '909599',
    '900084',
    '901335',
    '905475',
    '900690',
    '905483',
    '900703',
    '906662',
    '901343',
    '904456',
    '900252',
    '900279',
    '906099',
    '904464',
    '906670',
    '906101',
    '905838',
    '904704',
    '903525',
    '902514',
    '903971',
    '905491',
    '904480',
    '901909',
    '906689',
    '909695',
    '901351',
    '904579',
    '906144',
    '900287',
    '906195',
    '901378',
    '903998',
    '906718',
    '900738',
    '906734',
    '902805',
    '902960',
    '903576',
    '905950',
    '905379',
    '901087',
    '902725',
    '901933',
];

const validNISortCodes = [
    '900295',
    '900770',
    '902047',
    '902055',
    '902071',
    '902127',
    '902194',
    '902207',
    '902223',
    '902282',
    '902290',
    '902311',
    '902338',
    '902354',
    '902426',
    '902442',
    '902450',
    '902653',
    '904800',
    '904819',
    '904851',
    '904886',
    '904974',
    '904982',
    '905002',
    '905010',
    '905053',
    '905096',
    '902100',
    '902346',
    '902389',
    '903154',
    '904798',
    '904843',
    '905045',
    '909126',
    '902178',
    '902258',
    '902274',
    '902303',
    '902362',
    '904958',
    '905037',
    '905061',
    '909118',
    '909142',
    '909169',
];

const validGBSortCodes = [
    '300050',
    '300103',
    '301022',
    '301027',
    '301142',
    '301154',
    '301155',
    '301170',
    '301433',
    '301443',
    '301458',
    '301466',
    '301474',
    '301482',
    '301485',
    '301510',
    '301514',
    '301517',
    '301525',
    '301573',
    '301607',
    '301657',
    '839112',
    '839121',
]

export {
    validROISortCodes,
    validNISortCodes,
    validGBSortCodes
};